import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-grow-1" }
const _hoisted_4 = { class: "me-7 mb-4" }
const _hoisted_5 = { class: "symbol symbol-100px symbol-fixed position-relative" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px" }, null, -1)
const _hoisted_8 = { class: "flex-grow-1" }
const _hoisted_9 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = { class: "d-flex align-items-center mb-2" }
const _hoisted_12 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
}
const _hoisted_13 = { href: "#" }
const _hoisted_14 = { class: "svg-icon svg-icon-1 svg-icon-success" }
const _hoisted_15 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_16 = {
  href: "#",
  class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
}
const _hoisted_17 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_18 = { class: "flex-grow-1" }
const _hoisted_19 = { class: "d-flex flex-wrap fw-bold fs-6" }
const _hoisted_20 = { class: "d-flex align-items-center text-hover-primary me-5 mb-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold d-block" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-envelope mr-2" })
], -1)
const _hoisted_22 = { class: "d-flex flex-wrap fw-bold fs-6" }
const _hoisted_23 = { class: "d-flex align-items-center text-hover-primary me-5 mb-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold d-block" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-phone mr-2" })
], -1)
const _hoisted_25 = { class: "d-flex flex-wrap fw-bold fs-6" }
const _hoisted_26 = { class: "d-flex align-items-center text-hover-primary me-5 mb-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold d-block" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-address-card mr-2" })
], -1)
const _hoisted_28 = { class: "card mb-5 mb-xl-10" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_signin_method",
  style: {"background":"#e8f5e9"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-boldest m-0 text-light" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fas fa-key mr-2 text-light" }),
      /*#__PURE__*/_createTextVNode(" Change Password ")
    ])
  ])
], -1)
const _hoisted_30 = {
  id: "kt_account_signin_method",
  class: "collapse show"
}
const _hoisted_31 = { class: "card-body border-top p-9" }
const _hoisted_32 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_33 = {
  key: 0,
  id: "kt_signin_password"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Password", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-600" }, "************", -1)
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = {
  id: "kt_signin_password_edit",
  class: "flex-row-fluid"
}
const _hoisted_38 = {
  key: 0,
  class: "mx-2 fs-6 fw-bold text-gray-600 mb-4"
}
const _hoisted_39 = { class: "row mb-6" }
const _hoisted_40 = { class: "col-lg-4" }
const _hoisted_41 = { class: "fv-row mb-0" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", {
  for: "currentpassword",
  class: "form-label required fs-6 fw-bolder mb-3"
}, "Current Password", -1)
const _hoisted_43 = { class: "fv-plugins-message-container" }
const _hoisted_44 = { class: "fv-help-block" }
const _hoisted_45 = { class: "col-lg-4" }
const _hoisted_46 = { class: "fv-row mb-0" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", {
  for: "newpassword",
  class: "form-label required fs-6 fw-bolder mb-3"
}, "New Password", -1)
const _hoisted_48 = { class: "fv-plugins-message-container" }
const _hoisted_49 = { class: "fv-help-block" }
const _hoisted_50 = { class: "col-lg-4" }
const _hoisted_51 = { class: "fv-row mb-0" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", {
  for: "confirmpassword",
  class: "form-label required fs-6 fw-bolder mb-3"
}, "Confirm New Password", -1)
const _hoisted_53 = { class: "fv-plugins-message-container" }
const _hoisted_54 = { class: "fv-help-block" }
const _hoisted_55 = { class: "d-flex" }
const _hoisted_56 = ["data-kt-indicator"]
const _hoisted_57 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_58 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_60 = {
  key: 1,
  id: "kt_signin_password_button",
  class: "ms-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: 
                this.userInfo?.employee?.attach_file_info?.file_path
                  ? _ctx.api_url +
                    this.userInfo?.employee?.attach_file_info?.file_path
                  : 'media/avatars/blank.png'
              
              }, null, 8, _hoisted_6),
              _hoisted_7
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("a", _hoisted_12, _toDisplayString(this.employee?.name), 1),
                  _createElementVNode("a", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen026.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("a", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com006.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(this.userInfo?.employee?.entity_organogram[0]
                      ?.entitytyperole?.role_title), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createTextVNode("Email : " + _toDisplayString(this.employee?.email), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createTextVNode("Contact : " + _toDisplayString(this.employee?.mobile), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createTextVNode(" Present Address : " + _toDisplayString(this.employee?.present_address), 1)
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.load]
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _hoisted_29,
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            (!_ctx.showPassform)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_36))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_37, [
              (_ctx.showPassform)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, " Password must contain at least 1 uppercase, lowercase, number, special symbol and 8 characters. "))
                : _createCommentVNode("", true),
              (_ctx.showPassform)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 1,
                    onSubmit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.formSubmit())),
                    id: "kt_signin_change_password",
                    class: "form",
                    novalidate: "novalidate",
                    "validation-schema": _ctx.changePassword
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _hoisted_42,
                            _createVNode(_component_Field, {
                              modelValue: _ctx.userPass.currentPass,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userPass.currentPass) = $event)),
                              type: "password",
                              class: "form-control form-control-sm form-control-solid fw-bold fs-6",
                              name: "currentpassword",
                              id: "currentpassword"
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("div", _hoisted_44, [
                                _createVNode(_component_ErrorMessage, { name: "currentpassword" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _hoisted_47,
                            _createVNode(_component_Field, {
                              modelValue: _ctx.userPass.newPass,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userPass.newPass) = $event)),
                              type: "password",
                              class: "form-control form-control-sm form-control-solid fw-bold fs-6",
                              name: "newpassword",
                              id: "newpassword"
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("div", _hoisted_49, [
                                _createVNode(_component_ErrorMessage, { name: "newpassword" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _hoisted_52,
                            _createVNode(_component_Field, {
                              modelValue: _ctx.userPass.confirmPass,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userPass.confirmPass) = $event)),
                              type: "password",
                              class: "form-control form-control-sm form-control-solid fw-bold fs-6",
                              name: "confirmpassword",
                              id: "confirmpassword"
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("div", _hoisted_54, [
                                _createVNode(_component_ErrorMessage, { name: "confirmpassword" })
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("button", {
                          "data-kt-indicator": _ctx.loading ? 'on' : null,
                          id: "kt_password_submit",
                          type: "submit",
                          ref: "updatePasswordButton",
                          class: "btn btn-success me-2 px-6"
                        }, [
                          (!_ctx.loading)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_57, " Update Password "))
                            : _createCommentVNode("", true),
                          (_ctx.loading)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_58, [
                                _createTextVNode(" Please wait... "),
                                _hoisted_59
                              ]))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_56),
                        _createElementVNode("button", {
                          id: "kt_password_cancel",
                          type: "button",
                          class: "btn btn-color-gray-400 btn-active-light-primary px-6",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.passBack && _ctx.passBack(...args)))
                        }, " Cancel ")
                      ])
                    ]),
                    _: 1
                  }, 8, ["validation-schema"]))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.showPassform)
              ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.passwordFormDisplay && _ctx.passwordFormDisplay(...args))),
                    class: "btn btn-light fw-boldest"
                  }, " Reset Password ")
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}